var _defs, _rect, _defs2, _rect2, _path, _g, _rect3, _path2, _g2, _g3, _defs3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCcotsMainLogoTransparentbg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 2400,
    height: 1800,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 0,
    height: 0,
    viewBox: "0 0 340.000000 250.000000",
    preserveAspectRatio: "xMidYMid meet",
    colorInterpolationFilters: "sRGB",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "watermark",
    patternUnits: "userSpaceOnUse",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,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",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "rgba(255,255,255,0)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    width: 2400,
    height: 1800,
    viewBox: "0 0 340.000000 250.000000",
    preserveAspectRatio: "xMidYMid meet",
    colorInterpolationFilters: "sRGB",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: 92,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fa71cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9b59b6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 93,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f9d423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f83600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 94,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0064d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1cb0f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 95,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f00978"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3f51b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 96,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7873f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ec77ab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 97,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f9d423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#e14fad"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 98,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#009efd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2af598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 99,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffcc00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00b140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 100,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#d51007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ff8177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 102,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#a2b6df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0c3483"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 103,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7ac5d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#eea2a2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 104,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00ecbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#007adf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 105,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#b88746"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fdf5a6"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "iconmbgsvg",
    transform: "translate(82.39999389648438,39.770790100097656)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#2a429b",
    "hollow-target": "textRect"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.600006103515625,0)",
    mask: "url(#4140b988-a4e9-4247-a34d-d3bd90db49c5)"
  }, /*#__PURE__*/React.createElement("g", null, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#2a429b",
    fillOpacity: 0,
    strokeWidth: 2,
    x: 0,
    y: 0,
    width: 150,
    height: 170.4584195095343,
    className: "image-rect"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    x: 0,
    y: 0,
    width: 150,
    height: 170.4584195095343,
    filtersec: "colorsb8817579778",
    className: "image-svg-svg primary",
    style: {
      overflow: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 137.02999877929688 155.72000122070312",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.62 0v10.82L59.42.44 0 34.12l7.77 4.61L0 43.15V113l8.12-4.82V122l59.42 33.68V150l10.07 5.72L137 121.41l-8-4.62 8-4.75V34.12zm20.16 65.46v33.29l-30.24 17.33v-5.69L35.46 92l3.79-2.25V57.41l38.37-21.93v10.29l27.45 15.56z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#f12b93",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M59.42.44L0 34.12l39.25 23.29 59.96-34.27L59.42.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0429e",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M0 43.15v69.86l39.25-23.29V20.83L0 43.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2a429b",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M97.78 65.46v69.87l39.25-23.29V43.15L97.78 65.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6c1586",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M8.12 76.27v45.76l59.42 33.68v-45.32L8.12 76.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#58bfd9",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M77.62 0v45.77l59.41 33.67V34.12L77.62 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8d59a8",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M97.78 98.75l-59.96 34.37 39.8 22.59 59.41-34.3-39.25-22.66z"
  }))))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,71.02420997619629)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "",
    className: "tp-name"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.41 0L26.63 0Q28.71 0 30.19-1.48L30.19-1.48Q31.64-2.93 31.64-5.01L31.64-5.01 31.64-9.2 24.96-9.2 24.96-6.69 9.08-6.69 9.08-21.72 24.96-21.72 24.96-19.23 31.64-19.23 31.64-23.4Q31.64-25.47 30.19-26.95L30.19-26.95Q28.71-28.41 26.63-28.41L26.63-28.41 7.41-28.41Q5.33-28.41 3.87-26.95L3.87-26.95Q2.4-25.47 2.4-23.4L2.4-23.4 2.4-5.01Q2.4-2.93 3.87-1.48L3.87-1.48Q5.33 0 7.41 0L7.41 0ZM36.44-6.69L36.44 0 43.12 0 43.12-6.69 36.44-6.69ZM52.93 0L72.15 0Q74.23 0 75.71-1.48L75.71-1.48Q77.16-2.93 77.16-5.01L77.16-5.01 77.16-9.2 70.47-9.2 70.47-6.69 54.6-6.69 54.6-21.72 70.47-21.72 70.47-19.23 77.16-19.23 77.16-23.4Q77.16-25.47 75.71-26.95L75.71-26.95Q74.23-28.41 72.15-28.41L72.15-28.41 52.93-28.41Q50.85-28.41 49.39-26.95L49.39-26.95Q47.91-25.47 47.91-23.4L47.91-23.4 47.91-5.01Q47.91-2.93 49.39-1.48L49.39-1.48Q50.85 0 52.93 0L52.93 0ZM88.64-11.42L88.64-21.72 98.96-21.72 88.64-11.42ZM103.68-17.01L103.68-6.69 93.37-6.69 103.68-17.01ZM86.97 0L105.35 0Q107.43 0 108.91-1.48L108.91-1.48Q110.36-2.93 110.36-5.01L110.36-5.01 110.36-23.4Q110.36-25.47 108.91-26.95L108.91-26.95Q107.43-28.41 105.35-28.41L105.35-28.41 86.97-28.41Q84.89-28.41 83.43-26.95L83.43-26.95Q81.95-25.47 81.95-23.4L81.95-23.4 81.95-5.01Q81.95-2.93 83.43-1.48L83.43-1.48Q84.89 0 86.97 0L86.97 0ZM143.56-28.41L115.16-28.41 115.16-21.72 126.02-21.72 126.02 0 132.7 0 132.7-21.72 143.56-21.72 143.56-28.41ZM177.6-5.01L177.6-13.4Q177.6-14.87 176.69-16.01L176.69-16.01Q175.79-17.15 174.33-17.47L174.33-17.47 173.97-17.55 155.04-17.57 155.04-21.72 170.92-21.72 170.92-19.23 177.6-19.23 177.6-23.4Q177.6-25.47 176.15-26.95L176.15-26.95Q174.67-28.41 172.59-28.41L172.59-28.41 153.37-28.41Q151.29-28.41 149.83-26.95L149.83-26.95Q148.36-25.47 148.36-23.4L148.36-23.4 148.36-15.05Q148.36-13.56 149.27-12.42L149.27-12.42Q150.19-11.28 151.63-10.96L151.63-10.96 151.99-10.88 170.92-10.86 170.92-6.69 155.04-6.69 155.04-9.2 148.36-9.2 148.36-5.01Q148.36-2.93 149.83-1.48L149.83-1.48Q151.29 0 153.37 0L153.37 0 172.59 0Q174.67 0 176.15-1.48L176.15-1.48Q177.6-2.93 177.6-5.01L177.6-5.01Z",
    transform: "translate(-2.4000000953674316, 28.40999984741211)"
  })))))))), /*#__PURE__*/React.createElement("mask", {
    id: "4140b988-a4e9-4247-a34d-d3bd90db49c5"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("g", null, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fillOpacity: 1,
    strokeWidth: 2,
    x: 0,
    y: 0,
    width: 150,
    height: 170.4584195095343,
    className: "image-rect"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    x: 0,
    y: 0,
    width: 150,
    height: 170.4584195095343,
    filtersec: "colorsb8817579778",
    className: "image-svg-svg primary",
    style: {
      overflow: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 137.02999877929688 155.72000122070312",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.62 0v10.82L59.42.44 0 34.12l7.77 4.61L0 43.15V113l8.12-4.82V122l59.42 33.68V150l10.07 5.72L137 121.41l-8-4.62 8-4.75V34.12zm20.16 65.46v33.29l-30.24 17.33v-5.69L35.46 92l3.79-2.25V57.41l38.37-21.93v10.29l27.45 15.56z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M59.42.44L0 34.12l39.25 23.29 59.96-34.27L59.42.44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M0 43.15v69.86l39.25-23.29V20.83L0 43.15z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M97.78 65.46v69.87l39.25-23.29V43.15L97.78 65.46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M8.12 76.27v45.76l59.42 33.68v-45.32L8.12 76.27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M77.62 0v45.77l59.41 33.67V34.12L77.62 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M97.78 98.75l-59.96 34.37 39.8 22.59 59.41-34.3-39.25-22.66z"
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12.600006103515625,71.02420997619629)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillOpacity: 1,
    x: -3.5,
    y: -3.5,
    width: 182.20001220703125,
    height: 35.40999984741211
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillOpacity: 1,
    x: -3.5,
    y: -3.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12.600006103515625,71.02420997619629)",
    fill: "black"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "",
    className: "tp-name"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.41 0L26.63 0Q28.71 0 30.19-1.48L30.19-1.48Q31.64-2.93 31.64-5.01L31.64-5.01 31.64-9.2 24.96-9.2 24.96-6.69 9.08-6.69 9.08-21.72 24.96-21.72 24.96-19.23 31.64-19.23 31.64-23.4Q31.64-25.47 30.19-26.95L30.19-26.95Q28.71-28.41 26.63-28.41L26.63-28.41 7.41-28.41Q5.33-28.41 3.87-26.95L3.87-26.95Q2.4-25.47 2.4-23.4L2.4-23.4 2.4-5.01Q2.4-2.93 3.87-1.48L3.87-1.48Q5.33 0 7.41 0L7.41 0ZM36.44-6.69L36.44 0 43.12 0 43.12-6.69 36.44-6.69ZM52.93 0L72.15 0Q74.23 0 75.71-1.48L75.71-1.48Q77.16-2.93 77.16-5.01L77.16-5.01 77.16-9.2 70.47-9.2 70.47-6.69 54.6-6.69 54.6-21.72 70.47-21.72 70.47-19.23 77.16-19.23 77.16-23.4Q77.16-25.47 75.71-26.95L75.71-26.95Q74.23-28.41 72.15-28.41L72.15-28.41 52.93-28.41Q50.85-28.41 49.39-26.95L49.39-26.95Q47.91-25.47 47.91-23.4L47.91-23.4 47.91-5.01Q47.91-2.93 49.39-1.48L49.39-1.48Q50.85 0 52.93 0L52.93 0ZM88.64-11.42L88.64-21.72 98.96-21.72 88.64-11.42ZM103.68-17.01L103.68-6.69 93.37-6.69 103.68-17.01ZM86.97 0L105.35 0Q107.43 0 108.91-1.48L108.91-1.48Q110.36-2.93 110.36-5.01L110.36-5.01 110.36-23.4Q110.36-25.47 108.91-26.95L108.91-26.95Q107.43-28.41 105.35-28.41L105.35-28.41 86.97-28.41Q84.89-28.41 83.43-26.95L83.43-26.95Q81.95-25.47 81.95-23.4L81.95-23.4 81.95-5.01Q81.95-2.93 83.43-1.48L83.43-1.48Q84.89 0 86.97 0L86.97 0ZM143.56-28.41L115.16-28.41 115.16-21.72 126.02-21.72 126.02 0 132.7 0 132.7-21.72 143.56-21.72 143.56-28.41ZM177.6-5.01L177.6-13.4Q177.6-14.87 176.69-16.01L176.69-16.01Q175.79-17.15 174.33-17.47L174.33-17.47 173.97-17.55 155.04-17.57 155.04-21.72 170.92-21.72 170.92-19.23 177.6-19.23 177.6-23.4Q177.6-25.47 176.15-26.95L176.15-26.95Q174.67-28.41 172.59-28.41L172.59-28.41 153.37-28.41Q151.29-28.41 149.83-26.95L149.83-26.95Q148.36-25.47 148.36-23.4L148.36-23.4 148.36-15.05Q148.36-13.56 149.27-12.42L149.27-12.42Q150.19-11.28 151.63-10.96L151.63-10.96 151.99-10.88 170.92-10.86 170.92-6.69 155.04-6.69 155.04-9.2 148.36-9.2 148.36-5.01Q148.36-2.93 149.83-1.48L149.83-1.48Q151.29 0 153.37 0L153.37 0 172.59 0Q174.67 0 176.15-1.48L176.15-1.48Q177.6-2.93 177.6-5.01L177.6-5.01Z",
    transform: "translate(-2.4000000953674316, 28.40999984741211)"
  }))))))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", {
    "v-gra": "od"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcotsMainLogoTransparentbg);
export default __webpack_public_path__ + "static/media/ccots Main Logo Transparent bg.371c348ccd739043cd23a1a0c0f0eaac.svg";
export { ForwardRef as ReactComponent };